import list_icon from '@/assets/img/device/nd63/list_icon.png'
import { ND63 } from './nd63'

export class ND63Cyan extends ND63 {
  name: string = 'ND63_CYAN'
  icon: string = list_icon
  width: number = 634
}
